import React from "react";
import { FaShieldAlt } from "react-icons/fa";
import { SettingsSubgroupHeader } from "./SettingsSectionShell";
import SettingsFieldCard from "./SettingsFieldCard";
import valuesEqual from "./hooks/valuesEqual";

const PREFERRED_ORDER = [
  "userPassword",
  "adminPassword",
  "servicePassword",
  "developerPassword",
  "auth",
];

const COLOR = "red";

/**
 * Şifre Ayarları — artık kendi sekmesi yok, "Sistem" bölümünün alt grubu
 * olarak ProfileSettingsSection içinde render edilir. Başlık makinedeki menü
 * adıyla aynıdır (PasswordSetting = "Şifre Ayarları"). Yazma grubu değişmedi:
 * `profile.security`.
 */
export default function SecuritySection({
  data,
  onChange,
  originalData,
  showHeader = true,
}) {
  if (!data) return null;
  const allKeys = Object.keys(data);
  if (allKeys.length === 0) return null;
  const orderedKnown = PREFERRED_ORDER.filter((k) => k in data);
  const extras = allKeys.filter((k) => !PREFERRED_ORDER.includes(k)).sort();
  const keys = [...orderedKnown, ...extras];

  return (
    <div>
      {showHeader && (
        <SettingsSubgroupHeader
          icon={FaShieldAlt}
          title="Şifre Ayarları"
          count={keys.length}
          color={COLOR}
        />
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
        {keys.map((k) => {
          const setting = data[k];
          const orig = originalData?.[k]?.value;
          const isChanged =
            orig !== undefined && !valuesEqual(setting.value, orig);
          return (
            <SettingsFieldCard
              key={k}
              setting={setting}
              onChange={(value) =>
                onChange({ group: "profile.security", key: k, value })
              }
              isChanged={isChanged}
              originalValue={orig}
              color={COLOR}
            />
          );
        })}
      </div>
    </div>
  );
}
